import { render, staticRenderFns } from "./dict-table.vue?vue&type=template&id=3e575b8e&"
import script from "./dict-table.vue?vue&type=script&lang=js&"
export * from "./dict-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports